import * as React from "react";
import styled from "@emotion/styled";
import { Row, Col, Button } from "reactstrap";
import { MdPlayArrow } from "react-icons/md";

// Theme
import { Colors, Images } from "../../Themes";

// Utils
import { VIDEO_TUTORIALS_LINK } from "../../Utils/Consts";

const Wrapper = styled.div`
  & img {
    position: relative;
    top: 65px;
    height: 450px;
  }
  @media (max-width: 800px) {
    & img {
      top: 60px;
      height: auto;
      width: 300px;
    }
  }
`;

const Container = styled.div`
  background: ${Colors.snow};
  height: auto;
  padding-top: 30px;
  text-align: center;
  padding-bottom: 80px;
`;

const Heading = styled.h2`
  font-weight: 700;
  position: relative;
  top: 105px;
  font-size: 3.15em;
  @media (max-width: 800px) {
    font-size: 2.15em;
  }
`;

const SubHeading = styled.p`
  font-weight: 100;
  position: relative;
  top: 105px;
  font-size: 1.35em;
`;

const btnStyling = {
  width: "180px"
};

class CallToAction extends React.Component<{}> {
  render() {
    return (
      <Wrapper>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <Container>
              <Heading>Prevent downtime...before it happens.</Heading>
              <br />
              <br />
              <SubHeading>
                <a href={VIDEO_TUTORIALS_LINK} target="_blank">
                  <Button
                    style={btnStyling}
                    className="secondary-btn landing-page-banner-btn"
                  >
                    <MdPlayArrow size="1.5em" />
                    &nbsp;&nbsp;See how it works
                  </Button>
                </a>
              </SubHeading>
            </Container>
          </Col>
          <Col xs={12} md={6} lg={6} style={{ textAlign: "center" }}>
            <img alt="Home Page Illustration" src={Images.illustrationTwo} />
          </Col>
        </Row>
      </Wrapper>
    );
  }
}

export default CallToAction;



// WEBPACK FOOTER //
// ./src/Containers/Home/CallToAction.tsx